export enum OriginAPIEnum {
    MARKETPLACE_MAIN = 'marketplace',
    LP_ANIMA_MAIN = 'anima',
    LP_COGNA_MAIN = 'cogna',
    LP_TODAS_MARCAS = 'todas-marcas',
    LP_ESTACIO_DEALER = 'estacio-dealer',
    REPROCESSAMENTO = 'reprocessamento',
    ROOM_NEGOTIATION = 'room-negotiation',
    ANIMA_WHATSAPP_FLOW = 'anima-whatsapp-flow'
}